module.exports = __webpack_public_path__ + "img/zizhi2.693375d4.jpg";